import React from 'react'
import { StatusReasonTable } from '../component/statusReason/StatusReasonTable'

export const StatusReasonPage = () => {
  return (
    <><StatusReasonTable/></>
  )
}
